import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import {
  getInvitationlist,
  getJoinlist,
  getNotificationlist,
  updateInvitation,
} from "../../../redux/chatandnotification/action";

import getTimeDifference from "../../Common/TimeDifference";
import { useRouteBaseStateContext } from "../../../Context/RouteBaseStateContext";
import { isThisMobileScreen, decodeHtml } from "../../../assests/extention/commonfunction";
import ImageWithFallback from "../../../common/ImageWithFallback";
import ProfilePic from "../../../assests/imgs/Profileplaceholder.svg";
import { getDateFormate } from "../../Common/AllDateTimeReleventFormate";
import ProfileImageWithFallback from "../../../common/ProfileImageWithFallback";
import { getTimeFormat } from "../../../utils/timeformate";

export default function Notifications({ onhover6, setOnhover6 }) {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");

  const path = "Assets/scss/header.module.scss";

  // Redux State
  const notificationlists = useSelector(
    ({ chatandnotification: { getnotificationlists } }) => getnotificationlists
  );
  const ncount = useSelector(({ chatandnotification: { getnotificationcount } }) => getnotificationcount);
  const invitationlists = useSelector(({ chatandnotification: { getinvitationlists } }) => getinvitationlists);
  const joinlists = useSelector(({ chatandnotification: { getjoinlists } }) => getjoinlists);
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  const [activeTab, setActiveTab] = useState("all");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    if (onhover6) {
      const timer = setTimeout(() => {
        dispatch(getNotificationlist());
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [dispatch, onhover6]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleInvitationAction = (id, type, status) => {
    const data = { status, type, id };
    dispatch(updateInvitation(data, navigate));
    // window.location.reload()
  };

  const { setMyOrderroute, setReceivedOrderroute, setMyorderActiveprojectroute, setTeamroute, setManageActivecontestroute,
    setMyorderActivejobsroute, setMyorderPostedordersroute, setReceivedOrderActiveroute, setMyorderRecentprojectroute, setManageworkProjeteroute, setManageworkJobroute
  } = useRouteBaseStateContext();


  // Navigate to a specific post
  const navigateToPost = (item) => {
    console.log(item.type, item, 'item');

    const pathMap = {
      "0": `/${lan}`,
      "1": `/${lan}/dashboard/myorders/project/recent/${item.master_id}`,
      "2": `/${lan}/dashboard/myorders/contest/active/${item.master_id}`,
      "3": `/${lan}/dashboard/myorders/job/recent/${item.master_id}`,
      "4": `/${lan}/dashboard/managework/projects/applied/${item.master_id}`,
      "5": `/${lan}/dashboard/myorders/project/active/${item.master_id}`,
      "6": `/${lan}/dashboard/managework/contests/active/${item.master_id}`,
      "7": `/${lan}/dashboard/myorders/contest/active/${item.master_id}`,
      "8": `/${lan}/dashboard/managework/jobs/applied/${item.master_id}`,
      "9": `/${lan}/dashboard/myorders/job/active/${item.master_id}`,
      "10": `/${lan}/dashboard/myorders/contest/active/${item.master_id}`,
      "11": `/${lan}/dashboard/myorders/project/active/${item.master_id}`,
      "12": `/${lan}/account/chats`,
      "13": `/${lan}/dashboard/managework/projects/active/${item.master_id}`,
      "14": `/${lan}/dashboard/managework/jobs/active/${item.master_id}`,
      "15": `/${lan}/dashboard/manageteams`,
      "16": `/${lan}/dashboard/manageteams`,
      "17": `/${lan}/dashboard/manageteams`,
      "18": `/${lan}/dashboard/manageteams`,
      "19": `/${lan}/dashboard/manageprofile`,
      "20": `/${lan}/dashboard/membership`,
      "21": `/${lan}/dashboard/myorders/contest/active/${item.master_id}`,
      "22": `/${lan}/dashboard/myorders/contest/active/${item.master_id}`,
      "23": `/${lan}/dashboard/managework/projects/active/${item.master_id}`,
      "24": `/${lan}/dashboard/myorders/job/active/${item.master_id}`,
      "25": `/${lan}/dashboard/managework/jobs/active/${item.master_id}`,
      "26": `/${lan}/dashboard/manageteams`,
      "27": `/${lan}/dashboard/myorders/actionorderdetails/${item.master_id}`,
      "28": `/${lan}/dashboard/receivedorders/actionorderdetails/${item.master_id}`,
      "29": `/${lan}/dashboard/myorders`,
      "30": `/${lan}/dashboard/receivedorders`,
      "31": `/${lan}/dashboard/receivedorders/rentalproductsdetails/${item.master_id}`,
      "32": `/${lan}/dashboard/myorders/rentalproductsdetails/${item.master_id}`,
      "33": `/${lan}/dashboard/receivedorders/productforsaledetails/${item.master_id}`,
      "34": `/${lan}/dashboard/myorders/productforsaledetails/${item.master_id}`,
      "35": `/${lan}/dashboard/receivedorders`,
      "36": `/${lan}/dashboard/myorders`,
      "37": `/${lan}/dashboard/manageteams`,
      "38": `/${lan}/dashboard/receivedorders`,
      "39": `/${lan}/dashboard/receivedorders`,
      "40": `/${lan}/jobdetails/${item.master_id}`,
      "41": `/${lan}/projectdetails/${item.master_id}`,
      "42": `/${lan}/contestdetails/${item.master_id}`,
      "43": `/${lan}/jobdetails/${item.master_id}`,

      "46": `/${lan}/expertsprofiledetails/${item.master_id}`,
      "47": `/${lan}/searchmergersacquisitions`,
      "48": `/${lan}/packageddetails/${item.master_id}`,
      "49": `/${lan}/productdetails/${item.master_id}`,
      "50": `/${lan}/rentproductdetails/${item.master_id}`,
      "51": `/${lan}/auctiondetails/${item.master_id}`,
      "52": `/${lan}/dashboard/managework/projects`,
      "53": `/${lan}/dashboard/managework/jobs`,
    };

    if (item.type == 1) { setMyorderRecentprojectroute('Allproposals') }
    if (item.type == 9 || item.type == 24) { setMyorderActivejobsroute('Timesheet') }
    if (item.type == 11) { setMyorderActiveprojectroute('Messages') }
    if (item.type == 14) { setMyorderActivejobsroute('Timesheet') }
    if (item.type == 15) { setTeamroute('Tasklist') }
    if (item.type == 16) { setTeamroute('Tasklist') }
    if (item.type == 17) { setTeamroute('TeamOverview') }
    if (item.type == 18) { setTeamroute('Messages') }
    if (item.type == 21) { setManageActivecontestroute('Entries') }
    if (item.type == 22) { setManageActivecontestroute('Entries') }
    if (item.type == 23) { setMyorderActiveprojectroute('Messages') }
    if (item.type == 24) { setMyorderActivejobsroute('Messages') }
    if (item.type == 25) { setMyorderActivejobsroute('Messages') }
    if (item.type == 26) { setTeamroute('TeamOverview') }
    if (item.type == 29) { setMyorderPostedordersroute('PostedOrdersMergersAcquisitions') }
    if (item.type == 30) { setReceivedOrderroute('Activeorders'); setReceivedOrderActiveroute('AMergersAcquisitions'); }
    if (item.type == 35) { setReceivedOrderroute('Orderequests') }
    if (item.type == 36) { setMyOrderroute('MyOrderPurchasedorders') }
    if (item.type == 37) { setTeamroute('Tasklist') }
    if (item.type == 38) { setReceivedOrderroute('Orderequests'); }
    if (item.type == 39) { setReceivedOrderroute('Orderequests'); }
    if (item.type == 52) { setManageworkProjeteroute('DeclinedProjects'); }
    if (item.type == 53) { setManageworkJobroute('DeclinedJobs'); }


    const route = pathMap[item.type];
    navigate(route);
  };

  const notificationType = (item) => {
    return `${item.type}.`;
  };

  useEffect(() => {
    if (profile?.role_type == 4) {
      dispatch(getJoinlist());
    }
  }, [dispatch, onhover6]);

  useEffect(() => {
    if (profile?.role_type == 3) {
      dispatch(getInvitationlist());
    }
  }, [profile]);

  const labelss = {
    "0": "pending",
    "1": "accepted",
    "2": "rejected",
    "3": "removed",
    "4": "switched",
    "5": "left"
  }

  const navigatetodetailpage = (item) => {
    const id = item?.expert_id || item?.company_id
    navigate(`/${lan}/expertsprofiledetails/${id}`)
  }

  return (
    <div className="notification-section"
      onClick={() => setOnhover6('onhover6')}
      onMouseEnter={() => !isThisMobileScreen && setOnhover6(true)}
      onMouseLeave={() => !isThisMobileScreen && setOnhover6(false)}
    >
      <div className="notification-header">
        <div className="notification-first">
          <h4>Notifications</h4>
        </div>
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              data-toggle="tab"
              className={`nav-link ${activeTab == "all" ? "active" : ""}`}
              onClick={() => handleTabChange("all")}
            >
              All Notifications ({ncount.notification || 0})
            </a>
          </li>
          {profile?.role_type == 3 ? (
            <li className="nav-item">
              <a
                data-toggle="tab"
                className={`nav-link ${activeTab == "invite" ? "active" : ""}`}
                onClick={() => handleTabChange("invite")}
              >
                Invitations ({ncount.invites || 0})
              </a>
            </li>
          ) : profile?.role_type == 4 ? (
            <li className="nav-item">
              <a
                data-toggle="tab"
                className={`nav-link ${activeTab == "join" ? "active" : ""}`}
                onClick={() => handleTabChange("join")}
              >
                Join Requests ({ncount.join_requests || 0})
              </a>
            </li>
          ) : <></>}
        </ul>
      </div>

      <div className="notification-second tab-content">
        <div
          className={`tab-pane ${activeTab == "all" ? "active" : ""}`}
          id="allnotification"
        >
          <div className="notification-row">
            {notificationlists &&
              notificationlists.map((item, index) => (
                <div className="notification-img" key={index} style={{ background: item?.seen == 1 ? "" : '#f8f3f0' }}>
                  <div
                    className="right-name"
                    onClick={() => navigateToPost(item)}
                    style={{ cursor: "pointer" }}
                  >
                    <h6>{decodeHtml(item?.title)}</h6>
                    <h6>
                      <button className="buttons border-button">
                        <span>{decodeHtml(item?.message)}</span>
                      </button>
                    </h6>
                    <p>{getTimeDifference(item.created_on)}</p>
                  </div>

                </div>
              ))}
          </div>
        </div>

        {/* Mentions Tab */}
        <div className={`tab-pane ${activeTab == "mention" ? "active" : ""}`} id="mention">
          Hi Web Developer
        </div>
        {profile?.role_type == 3 ? (
          <div className={`tab-pane ${activeTab == "invite" ? "active" : ""}`} id="invite">
            {invitationlists &&
              invitationlists.map((item, index) => (
                <div className="notification-img mb-2" key={index}>
                  <div className="right-name ">
                    <h6>
                      <span style={{ cursor: "pointer" }} onClick={() => navigatetodetailpage(item)} >
                        <ProfileImageWithFallback url={item?.profile_image || ProfilePic} style={{ borderRadius: "5px", height: "40px", width: "40px" }} />
                      </span>

                      {item?.company_name ? (
                        <>
                          <span>{"  "} You got an invitation from {decodeHtml(item.company_name)}</span>
                          <p>{getDateFormate(item.created_on)} {getTimeFormat(item.created_on)}</p>
                        </>
                      ) : (
                        <span>{decodeHtml(item?.message)}</span>
                      )}
                    </h6>
                    {
                      item?.status == 0 ?
                        <div className="button-g d-flex align-items-center mt-1" style={{ columnGap: '10px' }}>
                          <button
                            className="accept background-button"

                            onClick={() =>
                              handleInvitationAction(item.id, 4, 1)
                            }
                          >
                            Accept
                          </button>
                          <button
                            className="reject border-button reject-btn"
                            onClick={() =>
                              handleInvitationAction(item.id, 4, 2)
                            }
                          >
                            Reject
                          </button>
                        </div>
                        :
                        <span>{labelss[item?.status]}</span>
                    }

                  </div>
                </div>
              ))}
          </div>
        ) : (
          <div className={`tab-pane   ${activeTab == "join" ? "active" : ""}`} id="join">
            <div className="right-cont-name">
              {joinlists &&
                joinlists.map((item, index) => (
                  <div className="notification-img mb-2" key={index}>
                    <div className="right-name" >
                      <h6>
                        <span style={{ cursor: "pointer" }} onClick={() => navigatetodetailpage(item)} >
                          <ProfileImageWithFallback url={item?.profile_image || ProfilePic} style={{ borderRadius: "5px", height: "40px", width: "40px" }} />
                        </span>
                        {'  '} You got an invitation from {decodeHtml(item.first_name)} {decodeHtml(item.last_name)}<br />
                        <p>{getDateFormate(item.created_on)} {getTimeFormat(item.created_on)}</p>
                      </h6>
                      {
                        item?.status == 0 ?
                          <div className="button-g d-flex align-items-center mt-1" style={{ columnGap: '10px' }}>
                            <button
                              className="reject border-button reject-btn"
                              onClick={() => handleInvitationAction(item.id, 8, 2)}
                            >
                              Reject
                            </button>
                            <button
                              className="accept background-button"
                              onClick={() => handleInvitationAction(item.id, 8, 1)}
                            >
                              Accept
                            </button>

                          </div>
                          :
                          <span style={{ fontWeight: '700' }}>{labelss[item?.status]}</span>
                      }
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
